<template>
	<div>
		<multiselect
			:placeholder="$t('select')"
			v-model="selected"
			:options="options"
			:class="validateError ? 'box-border-color' : ''"
			@input="handleInput($event, multiple)"
			label="text"
			track-by="value"
			:multiple="multiple"
			:select-label="''"
			:selected-label="''"
			:deselect-label="''"
			:searchable="true"
		>
			<template slot="selection" slot-scope="{ values, search, isOpen }">
                <span class="multiselect__single" v-if="values.length && !isOpen">
	                {{ translateNSelected(values) }}
                </span>
			</template>
			<span slot="noOptions">
                {{ $t("no_options") }}
            </span>
			<span slot="noResult">
                {{ $t("no_result") }}
            </span>
		</multiselect>
		<span class="invalid-feedback-custom" v-show="validateError" v-html="validateError"/>
	</div>
</template>

<script>
	// Helpers
	import translateNSelected from "@/helpers/translateNSelected";
	import handleInput from "@/helpers/handleInput";
	import setSelected from "@/helpers/setSelected";


	// Other
	import qs from "qs";
    import PrepExamDefinitionsService from "@/services/PrepExamDefinitionsService";

	export default {
		props: {
			value: {
				default: null,
			},
			multiple: {
				type: Boolean,
				default: false,
			},
			validateError: {
				type: String,
				default: null,
			},
            valueType:{
                type:String,
                default:'id'
            }
		},
		watch: {
			value: function (newValue) {
				this.selected = this.setSelected(newValue, this.options, this.multiple)
			},
		},
		data() {
			return {
				selected: null,
				options: [],
			}
		},
		created() {
			this.getOptions();
		},
		methods: {
			handleInput: handleInput,
			setSelected: setSelected,
			translateNSelected: translateNSelected,
			getOptions() {
				this.clearOptions()
				let config = {
					params: {
						limit: -1,
						filter: {},
						sort: '-id'
					},
					paramsSerializer: (params) => qs.stringify(params, {encode: false})
				}
				PrepExamDefinitionsService.getAll(config)
				               .then(response => {
					               const data = response.data.data;
					               data.map(item => {
                                       console.log(item[this.valueType])
						               this.options.push({
							               value: item[this.valueType],
							               text: item.academic_year + '-'+ item.level+'-' + item.exam,
						               });
					               });
				               })
				               .then(() => {
					               this.selected = this.setSelected(this.value, this.options, this.multiple)
					               if (this.selected == null || this.selected.length == 0) {
						               this.$emit("input", null)
					               }
				               })
			},
			clearOptions() {
				this.options = [];
				this.selected = null;
			}
		}
	}
</script>
